import React from 'react';
import { Box, Button, Card, Chip, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PetsRoundedIcon from '@mui/icons-material/PetsRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';

const dogs = [
  { name: 'Bobby', breed: 'Labrador Retriever', health: 'Gezondheid geldig' },
  { name: 'Luna', breed: 'Border Collie', health: 'Gezondheid geldig' },
];

export const CustomerPortalPage = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#fffafb', py: { xs: 2, md: 4 } }}>
    <Container maxWidth="lg">
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={2} alignItems={{ md: 'center' }}>
        <Box>
          <Typography variant="overline" color="text.secondary">Pippaya Hondenopvang · mijn account</Typography>
          <Typography variant="h3">Welkom bij Pippaya</Typography>
          <Typography color="text.secondary">Boek opvang, bekijk je reserveringen en houd de gegevens van je hond bij.</Typography>
        </Box>
        <Button variant="contained" size="large" startIcon={<CalendarMonthRoundedIcon />}>Nieuwe reservering</Button>
      </Stack>

      <Grid container spacing={2.5} sx={{ mt: 1 }}>
        <Grid item xs={12} md={4}><Card sx={{ p: 2.5, height: '100%' }}><CalendarMonthRoundedIcon /><Typography variant="h5" mt={1}>Nieuwe reservering</Typography><Typography color="text.secondary" mt={1}>Kies dagopvang of logeren en bekijk direct beschikbaarheid en prijs.</Typography><Button sx={{ mt: 2 }}>Reserveren</Button></Card></Grid>
        <Grid item xs={12} md={4}><Card sx={{ p: 2.5, height: '100%' }}><ListAltRoundedIcon /><Typography variant="h5" mt={1}>Mijn reserveringen</Typography><Typography color="text.secondary" mt={1}>Bekijk bevestigde boekingen, opties en eerdere opvang.</Typography><Button sx={{ mt: 2 }}>Bekijk reserveringen</Button></Card></Grid>
        <Grid item xs={12} md={4}><Card sx={{ p: 2.5, height: '100%' }}><PetsRoundedIcon /><Typography variant="h5" mt={1}>Mijn honden</Typography><Typography color="text.secondary" mt={1}>Bekijk gegevens en werk gezondheidsinformatie bij.</Typography><Button sx={{ mt: 2 }}>Bekijk honden</Button></Card></Grid>
      </Grid>

      <Card sx={{ p: 2.5, mt: 2.5 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">Mijn honden</Typography>
          <Button startIcon={<AddRoundedIcon />}>Nieuwe hond aanmelden</Button>
        </Stack>
        <Grid container spacing={2}>{dogs.map(d => <Grid item xs={12} sm={6} key={d.name}><Paper variant="outlined" sx={{ p: 2, boxShadow: 'none' }}><Stack direction="row" spacing={1.5} alignItems="center"><PetsRoundedIcon /><Box flex={1}><Typography fontWeight={800}>{d.name}</Typography><Typography variant="body2" color="text.secondary">{d.breed}</Typography></Box><Chip icon={<HealthAndSafetyRoundedIcon />} label={d.health} size="small" /></Stack></Paper></Grid>)}</Grid>
      </Card>

      <Card sx={{ p: 2.5, mt: 2.5 }}>
        <Typography variant="h5">Eerstvolgende reservering</Typography>
        <Paper variant="outlined" sx={{ p: 2, mt: 1.5, boxShadow: 'none' }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" gap={1}>
            <Box><Typography fontWeight={800}>Woensdag 1 oktober 2026</Typography><Typography color="text.secondary">Dagopvang · Bobby · 08.00–18.00 uur</Typography></Box><Chip label="Bevestigd" color="success" />
          </Stack>
        </Paper>
      </Card>

      <Card sx={{ p: 2.5, mt: 2.5 }}>
        <Typography variant="h5">Zo werkt reserveren</Typography>
        <Grid container spacing={1.5} mt={0.5}>{['Kies je hond(en)', 'Kies dagopvang of logeren', 'Kies datum of periode', 'Bekijk beschikbaarheid en prijs', 'Kies 3 dagen optie of definitief reserveren'].map((x,i)=><Grid item xs={12} sm={6} md key={x}><Paper variant="outlined" sx={{ p: 1.5, minHeight: 95, boxShadow:'none' }}><Typography fontWeight={900}>{i+1}. {x}</Typography></Paper></Grid>)}</Grid>
      </Card>

      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 3 }}>Werkprototype · fictieve gegevens · nog niet gekoppeld aan live klantaccounts.</Typography>
    </Container>
  </Box>
);
